<ng-content></ng-content>

<div class="uni-tooltip-cloud__content" #contentEl>
  <ng-content select="[tooltip]"></ng-content>
</div>
